import soon from "../assets/comingsoon.svg"
const ComingSoon = () => {
     return (
    <>
    <div className="py-5"></div>
     <section className="container text-center pt-5">
        <h2 className="heading"><span style={{ color: "#76ABAE" }}> Coming</span> Soon....</h2><div className="d-flex justify-content-center">
          <img
            src={soon}
            alt="soon"
            className="img-fluid"
            style={{ maxWidth: "600px" }}
          />
        </div>
     </section>   
    </>
    )
}
export default ComingSoon